import { VerticalFeature } from './types/internal-types';
import {
  Vertical,
  PaymentCycle,
  Brands,
  Country,
  RealEstateId,
  PageTitleKeys,
  Theme,
  PlanType,
  SectionCategory,
} from './enums';

/*
TODO: Export CardBrands from separate dir in payment-methods-icons package.
*/
export enum CardBrands {
  Amex = 'amex',
  BankTransfer = 'bankTransfer',
  Boleto = 'boleto',
  CarteBlue = 'carteBlue',
  CreditsPrepaidCard = 'creditsPrepaidCard',
  Diners = 'diners',
  Discover = 'discover',
  Elo = 'elo',
  Jcb = 'jcb',
  Maestro = 'maestro',
  Mastercard = 'mastercard',
  MercadoPagoRecurring = 'mercadoPagoRecurring',
  MpBanamex = 'mpBanamex',
  MpBancomer = 'mpBancomer',
  MpOxxo = 'mpOxxo',
  Payu = 'payu',
  MpSerfin = 'mpSerfin',
  RegDotRu = 'regDotRu',
  SepaDirectDebit = 'sepaDirectDebit',
  Solo = 'solo',
  Unionpay = 'unionpay',
  Visa = 'visa',
  Sofort = 'sofort',
}

export const PremuimProductTypeId = '8b1b47e6-9f58-4e59-b147-cac894bec8da';

export const WEBSITE_VERTICALS: Vertical[] = [
  Vertical.Music,
  Vertical.Video,
  Vertical.Default,
];

export const plansPageTabs = [
  PlanType.Website,
  PlanType.Business,
  PlanType.Enterprise,
];

export const appName = 'premium-purchase-plan';

export const PETRI_SCOPES = {
  PremiumPurchasePlan: 'premium-purchase-plan',
};

export const CycleMultiplier = {
  [PaymentCycle.YEAR3]: 36,
  [PaymentCycle.YEAR2]: 24,
  [PaymentCycle.YEARLY]: 12,
  [PaymentCycle.QUARTERLY]: 3,
  [PaymentCycle.MONTHLY]: 1,
};

export const verticals: { [key: string]: VerticalFeature[] } = {
  Website: [
    {
      key: 'free_hosting',
      icon: 'featureHosting',
    },
    {
      key: 'connect_domain',
      icon: 'featureDomain',
    },
    {
      key: 'increased_storage',
      icon: 'featureStorage',
    },
    {
      key: 'google_analytics',
      icon: 'featureAnalytics',
    },
    {
      key: 'premium_support',
      icon: 'featureSupport',
    },
    {
      key: 'customized_favicon',
      icon: 'featureSetup',
    },
  ],
  Default: [
    {
      key: 'accept_payments',
      icon: 'acceptPayments',
    },
    {
      key: 'ssl_certificate',
      icon: 'sslCertificate',
    },
    {
      key: 'payment_methods',
      icon: 'paymentMethods',
    },
    {
      key: 'connect_domain',
      icon: 'featureDomain',
    },
    {
      key: 'remove_ads',
      icon: 'removeAds',
    },
    {
      key: 'increased_storage',
      icon: 'featureStorage',
    },
  ],
  Bookings: [
    {
      key: 'bookings_intent.sell_your_services',
      icon: 'sellYourServices',
    },
    {
      key: 'bookings_intent.staff_management',
      icon: 'staffManagement',
    },
    {
      key: 'bookings_intent.memberships_and_packages',
      icon: 'membershipAndPackages',
    },
    {
      key: 'bookings_intent.sms_and_email_reminders',
      icon: 'smsAndEmailReminders',
    },
    {
      key: 'bookings_intent.bookings_on_the_go',
      icon: 'bookingOnTheGo',
    },
    {
      key: 'bookings_intent.bookings_analytics',
      icon: 'bookingAnalytics',
    },
  ],
  Stores: [
    {
      key: 'accept_payments',
      icon: 'acceptPayments',
    },
    {
      key: 'wix_mobile_app',
      icon: 'mobileApp',
    },
    {
      key: 'ssl_certificate',
      icon: 'sslCertificate',
    },
    {
      key: 'free_shipping',
      icon: 'shippingCost',
    },
    {
      key: 'remove_ads',
      icon: 'removeAds',
    },
    {
      key: 'connect_domain',
      icon: 'featureDomain',
    },
  ],

  'Restaurant-1': [
    {
      key: 'accept_payments',
      icon: 'acceptPayments',
    },
    {
      key: 'ssl_certificate',
      icon: 'sslCertificate',
    },
    {
      key: 'menu_builder',
      icon: 'menuBuilder',
    },
    {
      key: 'reservation',
      icon: 'tableReservations',
    },
    {
      key: 'take_order',
      icon: 'ordersOnline',
    },
    {
      key: 'remove_ads',
      icon: 'removeAds',
    },
  ],
  Hotels: [
    {
      key: 'accept_payments',
      icon: 'acceptPayments',
    },
    {
      key: 'ssl_certificate',
      icon: 'sslCertificate',
    },
    {
      key: 'online_booking',
      icon: 'onlineBooking',
    },
    {
      key: 'advanced_pricing',
      icon: 'advancedPricing',
    },
    {
      key: 'connect_domain',
      icon: 'featureDomain',
    },
    {
      key: 'remove_ads',
      icon: 'removeAds',
    },
  ],
  Events: [
    {
      key: 'accept_payments',
      icon: 'acceptPayments',
    },
    {
      key: 'flexible_ticket_fees',
      icon: 'tickets',
    },
    {
      key: 'payment_methods',
      icon: 'paymentMethods',
    },
    {
      key: 'connect_domain',
      icon: 'featureDomain',
    },
    {
      key: 'ssl_certificate',
      icon: 'sslCertificate',
    },
    {
      key: 'remove_ads',
      icon: 'removeAds',
    },
  ],
};

export const advancedShippingFeature = {
  key: 'advanced_shipping',
  icon: 'advancedShipping',
};

export const AcceptedPaymentMethodsFallback = [
  CardBrands.Visa,
  CardBrands.Mastercard,
  CardBrands.Amex,
  CardBrands.Discover,
];

export const supportedLangs = [
  'cs',
  'da',
  'de',
  'en',
  'es',
  'fi',
  'fr',
  'hi',
  'it',
  'ja',
  'ko',
  'nl',
  'no',
  'pl',
  'pt',
  'ru',
  'sv',
  'th',
  'tr',
  'uk',
  'zh',
];
export const trustedDomains = ['wix.com'];

export const TermsOfUseLinksByBrand: {
  [B in Brands]: { [T in 'terms' | 'privacy' | 'enterprise']: string };
} = {
  [Brands.WIX]: {
    privacy: 'https://www.wix.com/about/privacy',
    terms: 'https://www.wix.com/about/terms-of-use',
    enterprise: 'https://www.wix.com/about/terms-use-enterprise',
  },
  [Brands.EDITOR_X]: {
    privacy: 'https://www.editorx.com/info/privacy',
    terms: 'https://www.editorx.com/info/terms-of-use',
    enterprise: '',
  },
};

export const taxIncludedCountries = [
  Country.DE,
  Country.IL,
  Country.FR,
  Country.AU,
];
export const taxIncludedTranslationKey: {
  [key in Country.DE | Country.IL | Country.FR | Country.AU]: string;
} = {
  [Country.DE]: 'product.vat',
  [Country.FR]: 'product.vat',
  [Country.IL]: 'product.vat',
  [Country.AU]: 'product.gst',
};

const AppIntentElementsFallback = {
  website: PageTitleKeys.PLANS,
  business: PageTitleKeys.BUSINESS,
  enterprise: PageTitleKeys.ENTERPRISE,
  landingTab: PlanType.Website,
  recommendedSection: SectionCategory.DEFAULT,
  intent: Vertical.Default,
};

export const RealEstatesDeafultOffers = {
  [RealEstateId.AcceptPaymentMethods]: AcceptedPaymentMethodsFallback,
  [RealEstateId.AppIntentElementsInitialPurchase]: AppIntentElementsFallback,
  [RealEstateId.AppIntentElementsSecondUpgrade]: AppIntentElementsFallback,
};

export const AscendBundleHelperKeys: string[] = [
  'subscription_page.ascend_bundle_helper.body_email.campaigns',
  'subscription_page.ascend_bundle_helper.body_social.posts',
  'subscription_page.ascend_bundle_helper.body_chatbox',
  'subscription_page.ascend_bundle_helper.body_automations',
];

export const faqSubtitleMap: {
  [key in Theme]: { [faqSubtitle: string]: string };
} = {
  [Theme.Default]: {
    faqSubtitle: 'faq_section.faq_subtitle_support',
  },
  [Theme.AdvancedPlans]: {
    faqSubtitle: 'faq_section.faq_subtitle_support',
  },
  [Theme.EditorX]: { faqSubtitle: 'faq_section.editorx_faq_subtitle_support' },
};

export const faqEnterpriseCodeMap = {
  right_for_my_business: 'right_for_my_business',
  how_to_contact: 'how_to_contact',
  build_for_large_scale: 'build_for_large_scale',
  security: 'security',
  ngo_discounts: 'ngo_discounts',
  education_programs: 'education_programs',
};

export const faqCodeMap: { [key in Theme]: { [key: string]: string } } = {
  [Theme.Default]: {
    premiumPlan: 'what_is_a_premium_plan',
    premiumPlanNoVoucher: 'what_is_a_premium_plan_no_vouchers',
    canITry: 'can_i_try_wix_premium_for_free',
    customDomain: 'why_do_i_need_a_custom_domain',
    myDomain: 'how_do_i_get_my_domain',
    emailAddress: 'how_do_i_get_my_email_address',
    whatOnlinePayments: 'what_online_payments_are_accepted',
    googleVoucher: 'which_plans_come_with_vouchers',
    billingInfo: 'billing_information',
  },
  [Theme.AdvancedPlans]: {
    premiumPlan: 'what_is_a_premium_plan',
    premiumPlanNoVoucher: 'what_is_a_premium_plan_no_vouchers',
    canITry: 'can_i_try_wix_premium_for_free',
    customDomain: 'why_do_i_need_a_custom_domain',
    myDomain: 'how_do_i_get_my_domain',
    emailAddress: 'how_do_i_get_my_email_address',
    whatOnlinePayments: 'what_online_payments_are_accepted',
    googleVoucher: 'which_plans_come_with_vouchers',
    billingInfo: 'billing_information',
  },
  [Theme.EditorX]: {
    premiumPlan: 'editorx.what_is_a_premium_plan',
    premiumPlanNoVoucher: 'editorx.what_is_a_premium_plan_no_vouchers',
    canITry: 'can_i_try_editorx_premium_for_free',
    customDomain: 'editorx.why_do_i_need_a_custom_domain',
    myDomain: 'editorx.how_do_i_get_my_domain',
    emailAddress: 'how_do_i_get_my_email_address',
    whatOnlinePayments: 'editorx_what_online_payments_are_accepted',
    googleVoucher: 'editorx_which_plans_come_with_vouchers',
    billingInfo: 'editorx.billing_information',
  },
};
